module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_62-243f91c8b741366dc39c7a297b5d40f4.png";